export const TrialSuccessMessageCopies = {
  pro: "Your Pro+ trial has started. Create unlimited advanced Applets.",
  intermediate_pro:
    "Your Pro trial has started. Create and enable up to 20 Applets!",
}
